import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConnectivityService } from '@/app/core/services/connectivity.service';
import { LoadingBar } from '@/app/shared/ui/loading-bar';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingBar],
  host: {
    // Fill the viewport and allow the flex chain below to be height-bounded
    // (min-h-0) so descendant scroll containers own their overflow.
    class: 'flex min-h-0 w-full flex-auto flex-col',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app.html',
})
export class App {
  protected readonly connectivity = inject(ConnectivityService);
}
